<template>
    <div>
        <nav-breadcrumb :menu="[{label: ' 外勤任务列表'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import citysOptions from '../../utils/citys'
    export default {
        name: "BranchAssignmentList",
        data(){
            return{
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '任务编号',
                        field: 'a__assignmentNo'
                    },
                    {
                        label: '任务类型',
                        field: 'a__assignmentType',
                        formatter: function (r,c,v) {
                            if(v)
                                return   Status2CN(v)
                            else
                                return '未知'
                        }
                    },
                    {
                        label: '派发人',
                        field: 'a__assigner'
                    },
                    {
                        label: '分公司',
                        field: 'bo__branchName',
                    },
                    {
                        label: '接收人',
                        field: 'du__userName',
                    },
                    {
                        label: '派发时间',
                        field: 'a__frTime',
                    },
                    {
                        label: '状态',
                        field: 'a__assignmentStatus',
                        formatter: function (r,c,v) {
                            if(v)
                                return   Status2CN('assignmentStatus__'+v)
                            else
                                return '未知'
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'view',
                                            query: {
                                                assignmentId: row.a__assignmentId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '编辑',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'edit',
                                            query: {
                                                assignmentId: row.a__assignmentId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                }
                            }
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.$router.push({
                                path: 'add'
                            })
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        a__assignmentNo:'',
                        a__assignmentType:'',
                        a__assignmentStatus:'',
                        a__frTime:[],
                        bo__branchId:''
                    },
                    columns: [

                        {
                            label: '任务编号',
                            component: 'el-input',
                            field: 'a__assignmentNo',
                            span: 8
                        },
                        {
                            label: '任务类型',
                            component: 'el-select',
                            field: 'a__assignmentType',
                            options: [
                                {
                                    label:'房屋尽调',
                                    value:'fwjd'
                                },
                            ],
                            span: 8
                        },
                        {
                            label: '分公司',
                            component: 'el-select',
                            field: 'bo__branchId',
                            options: [],
                            span: 8
                        },
                        {
                            label: '派发日期',
                            component: 'date-range-picker',
                            field: 'a__frTime',
                            op: ['gteq', 'lteq'],
                            span: 16
                        },
                        {
                            label: '状态',
                            component: 'el-select',
                            field: 'a__assignmentStatus',
                            options: [
                                {
                                    label:'待处理',
                                    value:'Pending'
                                },
                                {
                                    label:'处理中',
                                    value:'Processing'
                                },
                                {
                                    label:'已完成',
                                    value:'Completed'
                                },
                                {
                                    label:'已取消',
                                    value:'Cancelled'
                                }
                            ],
                            span: 8
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
            this.getDataBranchOfficeSelect()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.sort.dataField': 'a.frTime',
                    'xlist.sort.order': 'desc'
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getBranchAssignmentList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
            getDataBranchOfficeSelect: function () {
                xhr.getDataBranchOfficeSelect(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            this.filters.columns[2].options = res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            removeItem: function (index, row) {
                removeItem(
                    xhr.deleteBranchOffice,
                    {
                        'bo.branchId' : row.bo__branchId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchAssignmentList.vue